import { createFileRoute, redirect } from "@tanstack/react-router";
import { EditLayout, ConsentSolutionProvider } from "@/features/consent-solutions";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Route = createFileRoute("/_authorized/consent-solutions/$csId")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["CONSENT_SOLUTION_VIEW"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <ConsentSolutionProvider>
      <EditLayout />
    </ConsentSolutionProvider>
  ),
});

export { Route };
